module.exports = __webpack_public_path__ + "img/print_handprint@2x.74491e2.jpg";